import type { EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const HEADING_DECORATION_PLUGIN_ID = 'headingDecoration' as const;
export type HeadingDecorationPluginId = typeof HEADING_DECORATION_PLUGIN_ID;

export type HeadingDecorationPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
    /** Recognised section labels (from `useHeadingKeywords`); see RP-6004 matcher. */
    headingLabels?: Set<string>;
  }
>;

export type HeadingDecorationPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    HeadingDecorationPluginOptions & {
      pluginID: HeadingDecorationPluginId;
      pluginName: string;
      component: ComponentType<any>;
      headingLabels?: Set<string>;
    }
>;
